import { requestJson } from "@/lib/api";

export type MaterialUnit =
  | "UNIDADE" | "PACOTE" | "ROLO" | "METRO" | "CENTIMETRO" | "KG" | "GRAMA" | "LITRO" | "MILILITRO";

export const MATERIAL_UNIT_LABELS: Record<MaterialUnit, string> = {
  UNIDADE: "Unidade",
  PACOTE: "Pacote",
  ROLO: "Rolo",
  METRO: "Metro",
  CENTIMETRO: "Centímetro",
  KG: "Quilograma",
  GRAMA: "Grama",
  LITRO: "Litro",
  MILILITRO: "Mililitro",
};

export interface PackagingMaterial {
  id: string;
  name: string;
  materialUnit: MaterialUnit;
  materialUnitLabel: string;
  currentCost: number | null;
  costReferenceDate: string | null;
  note: string | null;
  supplierId: string | null;
  active: boolean;
  version: number;
  updatedAt: string | null;
}

export interface PackagingMaterialCostHistoryEntry {
  id: string;
  changedAt: string;
  changedBy: string;
  origin: string;
  changedFields: string[];
  oldValues: string;
  newValues: string;
  materialName: string | null;
  materialUnit: string | null;
  referenceDate: string | null;
  note: string | null;
  /** Referência da importação XLSX (origem XLSX); null nas demais. */
  importId: string | null;
  /** Referência da aplicação de custo de NF (origem NF_FORNECEDOR); null nas demais e em registros antigos. */
  costApplicationId: string | null;
  /** Nome do emitente declarado no XML da NF (origem NF_FORNECEDOR); null em registros antigos/sem backfill. */
  nfSupplierName: string | null;
  /** Chave de acesso da NF-e para abrir o DANFE gerado do XML (origem NF_FORNECEDOR); null nas demais. */
  nfAccessKey: string | null;
  /** Número da NF (origem NF_FORNECEDOR); null nas demais. */
  nfNumber: string | null;
}

export interface PackagingMaterialPayload {
  name: string;
  materialUnit: MaterialUnit;
  currentCost: number | null;
  costReferenceDate: string | null;
  note: string | null;
  supplierId: string | null;
  version: number | null;
}

export async function fetchPackagingMaterials(): Promise<PackagingMaterial[]> {
  return requestJson<PackagingMaterial[]>("/api/v1/admin/packaging-materials");
}

export async function fetchPackagingMaterialHistory(id: string): Promise<PackagingMaterialCostHistoryEntry[]> {
  return requestJson<PackagingMaterialCostHistoryEntry[]>(`/api/v1/admin/packaging-materials/${id}/history`);
}

export async function createPackagingMaterial(payload: PackagingMaterialPayload): Promise<PackagingMaterial> {
  return requestJson<PackagingMaterial>("/api/v1/admin/packaging-materials", { method: "POST", body: payload });
}

export async function updatePackagingMaterial(id: string, payload: PackagingMaterialPayload): Promise<PackagingMaterial> {
  return requestJson<PackagingMaterial>(`/api/v1/admin/packaging-materials/${id}`, { method: "PUT", body: payload });
}

export async function setPackagingMaterialActive(id: string, active: boolean): Promise<PackagingMaterial> {
  return requestJson<PackagingMaterial>(`/api/v1/admin/packaging-materials/${id}/active`, {
    method: "PATCH",
    body: { active },
  });
}
